import { useGetBootstrapForCurrentTenantBootstrapGet } from "@/api-v3";

const ONE_HOUR_MS = 60 * 60 * 1000;

/**
 * App-start bootstrap data: tenant identity resolved from the request host.
 * Public and unauthenticated (GET /bootstrap), so it works pre-login.
 * Treated as effectively static for the lifetime of the app session — long
 * staleTime/gcTime — with a couple of retries to ride out transient network
 * blips.
 */
export const useBootstrap = () =>
  useGetBootstrapForCurrentTenantBootstrapGet({
    query: {
      staleTime: ONE_HOUR_MS,
      gcTime: ONE_HOUR_MS,
      retry: 2,
    },
  });
